import { render } from "./ContactTableComponent.vue?vue&type=template&id=260f9513"
import script from "./ContactTableComponent.vue?vue&type=script&lang=js"
export * from "./ContactTableComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__